import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import "react-toastify/dist/ReactToastify.css";
import {
  getCsvDataAction,
  fileUpload,
  getIntegrationTemplateUrl,
} from "../../store/actions";
import "../mapping/csvListUploadForm.css";
import _ from "lodash";
import React, { useState, useEffect } from "react";
import InlineFilePreview from "./PreviewAttachment";
import Trash from "../../assets/trashRed.svg";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import LoaderSpinner from "./Loader";
import PropTypes from "prop-types";
/* istanbul ignore next */
export function BulkPackageUploadDialog(props) {
  const [fileName, setFileName] = useState("");
  const [gridData, setGridData] = useState([]);
  const [File, setFile] = useState();
  const [parsedRows, setParsedRows] = useState([]);
  // Use shared InlineFilePreview component for consistent preview behavior
  const [errors, setErrors] = useState({});
  const [rowErrors, setRowErrors] = useState([]); // [{row: 1, messages: []}, ...]
  const createdBy = useSelector((state) => state?.auth?.user);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    Name: "",
    CarrierId: "",
    BaseMasterId: 0,
  });

  const [loader, setLoader] = useState(false);
  const [sampleTemplateUrl, setSampleTemplateUrl] = useState("");
  const [previewModalShow, setPreviewModalShow] = useState(false);

  useEffect(() => {
    if (!_.isEmpty(formData.csvTemp)) {
      fetchSampleTemplateUrl(formData.csvTemp);
    }
  }, [formData.csvTemp]);

  const fetchSampleTemplateUrl = async (integrationObj) => {
    let data = `integrationId=${integrationObj.value}&integrationName=${integrationObj.label}`
    let response = await Promise.resolve(dispatch(getIntegrationTemplateUrl(data)));
    if (response?.data?.Status === 200) {
      setSampleTemplateUrl(response?.data?.Entity);
    }
  }

  const getGridData = async () => {
    const resp = await Promise.resolve(dispatch(getCsvDataAction(`?createdBy=${createdBy?.Value?.employeeId}&sellerId=${createdBy?.Value?.sellerId}&companyId=${createdBy?.Value?.companyId}&isAdmin=${createdBy?.Value?.isSuperAdmin}&bulkUploadModuleId=8`)));
    if (resp.data.Status === 200) {
      setGridData(resp.data.EntityList);
      console.log("Response data", resp.data);
      console.log("Grid data", gridData);
    }
  };

  const validateForm = () => {
    let isValid = true;
    let errorsObj = {};
    if (!formData.Id) {
      isValid = false;
      errorsObj.Id = "Required field";
    }
    if (!fileName) {
      isValid = false;
      errorsObj.chooseFile = "Choose file";
    }
    setErrors(errorsObj);
    return isValid;
  };

  const handleCsvForm = (item) => {
    setFormData({
      Name: item.label,
      IntegrationId: item?.value,
      Id: item?.value,
      CreatedBy: createdBy,
      csvTemp: item,
    });
    setErrors({
      ...errors,
      Id: "",
    });
  };

  const handleCancelUpload = () => {
    props.onHide();
  };

  useEffect(() => {
      getGridData();
    }, [formData]);

  const handleUploadClick = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const fileNamechosen = file.name;

    // Client-side validation: only allow .csv
    const isCsv = fileNamechosen.toLowerCase().endsWith('.csv');
    if (!isCsv) {
      setErrors({ ...errors, chooseFile: 'Only CSV files are allowed' });
      setFile(null);
      setFileName("");
      setParsedRows([]);
      setRowErrors([]);
      return;
    }

    // Read and parse CSV for validation preview
    try {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result || '';
        const rows = parseCsvText(text);
        const errorsForRows = validateParsedRows(rows);
        setRowErrors(errorsForRows);
        setParsedRows(rows);
      };
      reader.readAsText(file);
    } catch (err) {
      console.error('Error reading CSV', err);
    }

    setFile(file);
    setFileName(fileNamechosen);
    setErrors({
      ...errors,
      chooseFile: "",
    });
  };

  // Simple CSV parser: handles quoted values and commas
  const parseCsvText = (text) => {
    const lines = text.split(/\r?\n/).filter(l => l.trim() !== '');
    if (!lines.length) return [];
    const headers = parseCsvLine(lines[0]);
    const data = [];
    for (let i = 1; i < lines.length; i++) {
      const values = parseCsvLine(lines[i]);
      const obj = {};
      for (let j = 0; j < headers.length; j++) {
        const key = headers[j]?.trim();
        obj[key] = values[j] !== undefined ? values[j].trim() : '';
      }
      data.push(obj);
    }
    return data;
  };

  const parseCsvLine = (line) => {
    const result = [];
    let current = '';
    let inQuotes = false;
    for (let i = 0; i < line.length; i++) {
      const ch = line[i];
      if (ch === '"') {
        if (inQuotes && line[i+1] === '"') { // escaped quote
          current += '"';
        } else {
          inQuotes = !inQuotes;
        }
      } else if (ch === ',' && !inQuotes) {
        result.push(current);
        current = '';
      } else {
        current += ch;
      }
    }
    result.push(current);
    return result;
  };

  // Validate parsed rows according to CarrierConnect package template
  const validateParsedRows = (rows) => {
    const errorsList = [];
    // Required columns per sample: PkgType, Weight, WeightUnit, Length, Width, Height, DimensionUnit, Carrier, Service, Package
  // requiredColumns intentionally omitted - validation checks specific fields by name
    rows.forEach((row, idx) => {
      const rowMsgs = [];
      // Normalize keys: some templates may not include trailing * in header
      const getVal = (names) => {
        for (const name of names) {
          if (row.hasOwnProperty(name)) return row[name];
        }
        // try case-insensitive
        const keys = Object.keys(row);
        for (const key of keys) {
          for (const name of names) {
            if (key.trim().toLowerCase() === name.trim().toLowerCase()) return row[key];
          }
        }
        return '';
      };

      const pkgType = getVal(['PkgType*','PkgType']);
      const weight = getVal(['Weight*','Weight']);
      const weightUnit = getVal(['WeightUnit*','WeightUnit']);
      const length = getVal(['Length*','Length']);
      const width = getVal(['Width*','Width']);
      const height = getVal(['Height*','Height']);
      const dimensionUnit = getVal(['DimensionUnit*','DimensionUnit']);
      const carrier = getVal(['Carrier*','Carrier']);
      const service = getVal(['Service*','Service']);
      const servicePackage = getVal(['Package*','Package']);

      if (!pkgType || pkgType.trim() === '') rowMsgs.push('PkgType is required');
      if (!weight || isNaN(parseFloat(weight))) rowMsgs.push('Weight is required and must be a number'); // NOSONAR
      if (!weightUnit || weightUnit.trim() === '') rowMsgs.push('WeightUnit is required');
      if (!length || isNaN(parseFloat(length))) rowMsgs.push('Length is required and must be a number'); // NOSONAR
      if (!width || isNaN(parseFloat(width))) rowMsgs.push('Width is required and must be a number'); // NOSONAR
      if (!height || isNaN(parseFloat(height))) rowMsgs.push('Height is required and must be a number'); // NOSONAR
      if (!dimensionUnit || dimensionUnit.trim() === '') rowMsgs.push('DimensionUnit is required');
      if (!carrier || carrier.trim() === '') rowMsgs.push('Carrier is required');
      if (!service || service.trim() === '') rowMsgs.push('Service is required');
      if (!servicePackage || servicePackage.trim() === '') rowMsgs.push('Package is required');

      if (rowMsgs.length) {
        errorsList.push({ row: idx + 2, messages: rowMsgs }); // +2 since header row and 1-indexed
      }
    });
    return errorsList;
  };

  const onTrashClick = () => {
    // Clear uploaded file and any parsed/validation state so errors disappear
    setFileName(null);
    setFile(null);
    setParsedRows([]);
    setRowErrors([]);
    setErrors({ ...errors, chooseFile: '' });
  };

  // Helper function to handle carrier connect validation and mapping
  const handleCarrierConnectUpload = async () => {
    if (typeof props.validateAndMapRows === 'function') {
      const result = await props.validateAndMapRows(parsedRows || []);
      if (!result.valid) {
        setRowErrors(result.rowErrors || []);
        toast.error('CSV contains mapping errors. Fix them and try again.');
        setLoader(false);
        return;
      }

      try {
        if (typeof props.renderData === 'function') props.renderData(result.mappedRows || []);
        toast.success('CSV parsed and packages added');
        props.onHide();
      } catch (e) {
        toast.error('Failed to process CSV data');
      } finally {
        setLoader(false);
      }
      return;
    }

    // Fallback: pass parsed rows directly
    if (typeof props.renderData === 'function') {
      try {
        props.renderData(parsedRows || []);
        toast.success('CSV parsed and packages added');
        props.onHide();
      } catch (e) {
        toast.error('Failed to process CSV data');
      } finally {
        setLoader(false);
      }
    }
  };

  // Helper function to create FormData for file upload
  const createFormData = () => {
    const fd = new FormData();
    fd.append("FormFile", File);
    fd.append("IntegrationId", formData?.IntegrationId);
    fd.append("CreatedBy", createdBy?.Value?.employeeId);
    fd.append("SellerId", createdBy?.Value?.sellerId);
    fd.append("CompanyId", createdBy?.Value?.companyId);
    fd.append("CompanySellerId", createdBy?.Value?.companySellerId);
    fd.append("Role", createdBy?.Value?.role);
    fd.append("ModifiedBy", createdBy?.Value?.employeeId);
    return fd;
  };

  // Helper function to open error file URL
  const openErrorFile = (errorFileUrl) => {
    try {
      window.open(errorFileUrl, '_blank');
    } catch (e) {
      // Fallback anchor click
      const link = document.createElement('a');
      link.href = errorFileUrl;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // NOSONAR
    }
  };

  // Helper function to handle successful upload response
  const handleUploadSuccess = (entity, errorFileUrl) => {
    if (errorFileUrl) {
      openErrorFile(errorFileUrl);
      toast.success(entity?.message || 'Upload returned errors');
    } else {
      toast.success(entity?.message || 'File uploaded successfully');
    }
    props.onHide();
  };

  // Helper function to handle upload error response
  const handleUploadError = (entity, errorFileUrl) => {
    if (errorFileUrl) {
      openErrorFile(errorFileUrl);
    }
    toast.error(entity?.message || 'Upload failed');
    setFileName("");
    setFormData({ ...formData, csvTemp: "", Id: "" });
  };

  // Helper function to handle legacy file upload
  const handleLegacyUpload = async () => {
    const fd = createFormData();
    setErrors({ ...errors, chooseFile: "" });

    const resp = await Promise.resolve(dispatch(fileUpload(fd)));
    const status = resp?.data?.Status || resp?.status;
    const entity = resp?.data?.Entity || resp?.data;
    const errorFileUrl = entity?.errorFileUrl || resp?.data?.ErrorFilePath || null;

    if (status === 200) {
      handleUploadSuccess(entity, errorFileUrl);
    } else {
      handleUploadError(entity, errorFileUrl);
    }
  };

  const handleUploadFile = async () => {
    // Prevent upload if client-side CSV validation found row errors
    if (rowErrors && rowErrors.length > 0) {
      toast.error('CSV contains validation errors. Fix them before uploading.');
      return;
    }

    if (!validateForm()) {
      return;
    }

    setLoader(true);

    try {
      // Handle carrier connect upload
      if (props.type === 'carrier connect') {
        await handleCarrierConnectUpload();
        return;
      }

      // Handle legacy file upload
      await handleLegacyUpload();
    } catch (error) {
      toast.error('An unexpected error occurred during upload');
      console.error('Upload error:', error);
    } finally {
      setLoader(false);
    }
  };

  const handleUploadCsv = async (e) => {
    const packageCSVFile = new FormData();
    packageCSVFile.append("File", File);
    setLoader(true);
    let resp = await Promise.resolve(dispatch(BulkUpload(packageCSVFile)));
    setLoader(false);
    if (resp.data.HasError) {
      toast.error(resp.data.Error);
      resp.data.ErrorFilePath && window.open(resp.data.ErrorFilePath);
    } else {
      toast.success('File uploaded successfully');
      props?.renderData(e, 'clear');
      handleCancelUpload();
    }
  };

  const getUploadHandler = () => {
    if (props.type === 2) return handleUploadCsv;
    return handleUploadFile;
  };


    return (
    <div>
      <Modal show={props.show} onHide={props.onHide} className="modalDeleteWrapper" size="lg">
        <Modal.Header closeButton>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
            <div style={{ flex: 1 }}>
              <h5 style={{ margin: 0 }}>Bulk Package Upload</h5>
              <div style={{ fontSize: 12, color: '#6c757d' }}>Upload CSV to import packages in bulk</div>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="selectSvcModal fontFix" style={{ position: 'relative' }}>
          {/* Loading Overlay */}
          {loader && (
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
              borderRadius: '0.375rem'
            }}>
              <LoaderSpinner />
              <div style={{ marginTop: 12, fontSize: 14, color: '#6c757d', fontWeight: 500 }}>
                Processing your file...
              </div>
            </div>
          )}
          {!props.hideIntegration && (
            <div className="row modal_input mb-3">
              <div className="col-4 formLabel csv_label alignRight">Select CSV Template</div>
              <div className="col-8">
                <div className={"select_react_Csv"}>
                  <Select
                    options={
                      gridData?.map((data) => ({ label: data.Name, value: data.Id }))
                    }
                    onChange={(value) => handleCsvForm(value)}
                    value={formData?.csvTemp}
                    placeholder="Select template.."
                    classNamePrefix={'list'}
                    styles={{
                      control: (provided) => ({ ...provided, minHeight: 38 }),
                    }}
                  />
                  <p className="error dialogError">{errors.Id}</p>
                </div>
              </div>
            </div>
          )}
          
          <div className="row modal_input">
            <div className="col-12">
              <div style={{ border: '1px dashed #ced4da', padding: 18, borderRadius: 6, display: 'flex', alignItems: 'center', gap: 16 }}>
                {/* Inline preview hidden by default to avoid expanding the dialog for large files.
                    Users can click the Preview button to open a dedicated preview modal. */}
                <div style={{ width: 150, minHeight: 64, borderRadius: 8, background: '#f8f9fa', display: 'none', color: '#6c757d', padding: 6 }}>
                  {/* intentionally hidden - use modal preview instead */}
                </div>
                <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                  {fileName ? (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        {/* Small file badge/icon to indicate selected file when preview is hidden */}
                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                          <div style={{ width: 34, height: 34, borderRadius: 6, background: '#fff', border: '1px solid #e9ecef', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#495057', fontWeight: 600 }}>
                            CSV
                          </div>
                          <div style={{ fontWeight: 600 }}>{fileName}</div>
                        </div>
                                {/* Preview button toggles inline preview panel (contained) */}
                                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setPreviewModalShow(true)}>
                                  Preview
                                </button>
                        </div>
                       <button
                        onClick={onTrashClick}
                        aria-label="Remove selected file"
                        style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            cursor: 'pointer',
                            display: 'inline-block',
                            lineHeight: 0
                        }}
                        >
                        <img className="trash-Img" src={Trash} alt="" style={{ width: 20 }} />
                       </button>
                    </div>
                  ) : (
                    <div style={{ width: '100%', textAlign: 'center', alignItems: "flex-end", display: 'flex', flexDirection: 'column', paddingRight: 70 }}>
                      <div style={{ fontSize: 14, color: '#495057', marginBottom: 8 }}>Choose a CSV file to upload</div>
                      <div style={{ paddingRight: 35 }}>
                        <label htmlFor={`actual-btn-6`} className="btn cus-seconday-bg-btn" style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                          <i className="fa fa-upload" style={{ marginRight: 0 }}></i> Choose File
                        </label>
                        <input type="file" name="file" accept=".csv" id={`actual-btn-6`} onChange={(e) => { handleUploadClick(e); }} hidden />
                        
                      </div>
                      {sampleTemplateUrl && (
                          <a rel="noreferrer" href={sampleTemplateUrl} target="_blank" style={{ marginLeft: 12, fontSize: 13 }}>
                            Download Sample Template
                          </a>
                        )}
                    </div>
                  )}
                  <p className="error file-upload">{errors.chooseFile}</p>
                </div>
              </div>
            {/* Show row mapping/validation errors if any - compact card */}
            {rowErrors && rowErrors.length > 0 && (
              <div className="row mt-3 justify-content-center">
                <div className="col-12 col-md-10">
                  <div className="card border-danger" role="alert" aria-live="polite">
                    <div className="card-header d-flex align-items-center justify-content-between" style={{backgroundColor: '#fff2f0', borderBottom: '1px solid rgba(220,53,69,.125)'}}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#c82333" viewBox="0 0 16 16" aria-hidden>
                          <path d="M8.982 1.566a1 1 0 0 0-1.964 0L5.5 8.5 3.482 2.566a1 1 0 1 0-1.964.868L4 9.5l-2.482 6.066a1 1 0 1 0 1.964.868L5.5 10.5l1.518 6.066a1 1 0 0 0 1.964 0L10.5 10.5l2.018 6.066a1 1 0 1 0 1.964-.868L12 9.5l2.482-6.066a1 1 0 0 0-1.964-.868L11 8.5 8.982 1.566z"/>
                        </svg>
                        <div>
                          <strong style={{ color: '#c82333' }}>CSV Row Errors</strong>
                          <div style={{ fontSize: 12, color: '#6c757d' }}>{rowErrors.length} issue{rowErrors.length > 1 ? 's' : ''} found</div>
                        </div>
                      </div>
                      <div>
                        <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => {
                          try {
                            const text = rowErrors.map(r => `Row ${r.row}: ${Array.isArray(r.messages) ? r.messages.join('; ') : r.messages}`).join('\n');
                            navigator.clipboard?.writeText(text);
                            toast.info('Row errors copied to clipboard');
                          } catch (e) {
                            // fallback
                            console.warn('Copy to clipboard failed', e);
                          }
                        }}>Copy</button>
                      </div>
                    </div>
                    <div className="card-body p-2" style={{ maxHeight: 180, overflowY: 'auto' }}>
                      <ul className="mb-0" style={{ paddingLeft: 16 }}>
                        {rowErrors.map((r) => (
                           <li key={`error-row-${r.row}`} style={{ marginBottom: 6 }}>
                            <strong>Row {r.row}:</strong> {Array.isArray(r.messages) ? r.messages.join('; ') : r.messages}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
            </div>
            
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20 }}>
            <button className="btn btn-secondary" onClick={() => handleCancelUpload()} disabled={loader}>
              Cancel
            </button>
                <button className="btn btn-primary" onClick={() => {
                  const handler = getUploadHandler?.();
                  if (typeof handler === 'function') handler();
                }} disabled={loader || !File || (rowErrors && rowErrors.length > 0)}>
              {loader ? 'Uploading...' : 'Upload'}
            </button>
          </div>
          {/* Preview is shown in an external popup modal (keeps Upload/Cancel visible in the main dialog) */}
        </Modal.Body>
      </Modal>

      {/* External preview popup - rendered as a sibling modal so it appears outside the main dialog */}
      <Modal show={previewModalShow} onHide={() => setPreviewModalShow(false)} size="xl" centered>
        <Modal.Header>
          <Modal.Title>File Preview</Modal.Title>
          {/* Custom close button in header using font-awesome icon as requested */}
          <button type="button" className="btn btn-link ms-auto p-0" onClick={() => setPreviewModalShow(false)} aria-label="Close" style={{ color: '#000' }}>
            <i className="fa fa-times"></i>
          </button>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto' }}>
          {File && (
            <InlineFilePreview file={File} onClose={() => setPreviewModalShow(false)} size="large" preferredMaxHeight={600} />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

BulkPackageUploadDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  renderData: PropTypes.func,
  validateAndMapRows: PropTypes.func,
  hideIntegration: PropTypes.bool
};
